/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Completed/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Completed({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Completed"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Completed.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="The image series capture process has been completed"
 size="large"
 textAlign="center"
/>
</div>
{children}
</React.Fragment>)
}